(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/views/oddset/matchen.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/views/oddset/matchen.js');

'use strict';

const SportinfoPathNames = svs.components.sportinfo.common.constants.SportinfoPathNames;
svs.game_results.views.Matchen = Marionette.View.extend({
  className: 'game-results',
  template(data) {
    return svs.game_results.templates.matchen(data);
  },
  tagName: 'ol',
  events: {
    'click .js-expand-big-statistics': 'expandBigStatistics'
  },
  modelEvents: {
    change: 'render'
  },
  initialize() {
    this.bigStat = new svs.game_results.BigStat();
  },
  getBigStatOptions(e) {
    const cleanedUpPathname = Backbone.history.location.pathname.replace(new RegExp("/".concat(Object.values(SportinfoPathNames).join('|'), "$"), 'i'), '');
    const pathname = cleanedUpPathname;
    const url = new URL(window.location);
    const query = new URLSearchParams(url.search);
    const matchId = e ? parseInt(e.currentTarget.id.split('-')[1], 10) : parseInt(query.get('match'), 10);
    const drawNumber = this.model.get('result') && this.model.get('result').filter(draw => draw.events[0].matchId === matchId)[0].drawNumber;
    const bigStatOptions = {
      productId: this.model.get('result') && this.model.get('result')[0].productId,
      drawNumber,
      matchId,
      searchParams: "match=".concat(matchId),
      queryKey: 'match',
      tab: svs.game_results.data.params.tab,
      domElement: svs.core.detect.formfactor.desktop() ? '#bigStatRegion' : '#bigstat-modal',
      modulePath: pathname
    };
    return bigStatOptions;
  },
  onRender() {
    let calenderDate;
    let capitalizedDay;
    const self = this;
    if (!svs.core.detect.formfactor.mobile()) {
      self.setUpDimensions();
      svs.core.detect.breakpoint.on('change', () => {
        self.setUpDimensions();
      });
      $('body').addClass('game-result-wrap');
    }
    const url = new URL(window.location);
    const query = new URLSearchParams(url.search);
    if (this.model.get('result') && query.has('match')) {
      const bigStatOptions = this.getBigStatOptions();
      this.bigStat.navToBigStat(bigStatOptions);
    }
    svs.game_results.models.calendar.on('change:date', () => {
      const domElement = svs.core.detect.formfactor.desktop() ? '#bigStatRegion' : '#bigstat-modal';
      this.bigStat.closeBigStat(domElement);
      svs.game_results.data.params.tab = undefined;
    });
    if (this.model.get('regCloseTime')) {
      calenderDate = dateFns.format(new Date(this.model.get('regCloseTime')), "EEEE d MMMM ' (v. 'w')'", {
        locale: dateFns.locales.sv
      });
      capitalizedDay = calenderDate.charAt(0).toUpperCase() + calenderDate.substring(1);
      $('.js-calendar-title').text(capitalizedDay);
    }
    _.defer(() => {
      $('html, body').animate({
        scrollTop: 0
      }, 'fast');
      $('.game-results-calendar').css('width', $('#gameResult').width());
    });
  },
  setUpDimensions() {
    const availableHeight = svs.game_results.utils.calcAvailableHeight();
    const $bigStatRegion = $('#bigStatRegion');
    $bigStatRegion.css('height', availableHeight);
    $bigStatRegion.addClass("".concat(this.model.get('product'), "-background animate animate-show"));
    $('#coupon').css({
      height: "".concat(availableHeight - 12, "px"),
      'overflow-y': 'auto',
      '-webkit-overflow-scrolling': 'touch'
    });
  },
  onDomRefresh() {
    if (!svs.core.detect.formfactor.mobile()) {
      $('body').addClass('game-result-wrap');
    }
  },
  expandBigStatistics(e) {
    const bigStatOptions = this.getBigStatOptions(e);
    this.bigStat.openBigStat(bigStatOptions);
    this.bigStat.updateBigStatUrlQuery(bigStatOptions);
  }
});

 })(window);